import { Controller } from "@hotwired/stimulus"
import { createRoot } from "react-dom/client"
import AwardsIndex from "../components/AwardsIndex"

// Mount point for the awards#index screen: takes the awards rendered by the
// view and hands them to React.
export default class extends Controller {
  static values = { awards: Array }

  connect() {
    this.root = createRoot(this.element)
    this.root.render(<AwardsIndex awards={this.awardsValue} />)
  }

  disconnect() {
    this.root?.unmount()
  }
}
